import type z from "zod";

// Custom resolver that uses safeParse
export const customZodResolver = (schema: z.ZodSchema<any>) => {
    return (values: any) => {
        try {
            const result = schema.safeParse(values);

            if (result.success) {
                return { values: result.data, errors: {} };
            }

            const errors: Record<string, any> = {};

            result.error.issues.forEach((issue) => {
                const path = issue.path.join('.');
                errors[path] = {
                    type: issue.code,
                    message: issue.message,
                };
            });

            return { values: {}, errors };
        } catch (error) {
            return { values: {}, errors: {} };
        }
    };
};